import React from 'react';
import classNames from 'classnames';
import { SectionTilesProps } from '../../utils/SectionProps';
import SectionHeader from './partials/SectionHeader';

const propTypes = {
  ...SectionTilesProps.types
}

const defaultProps = {
  ...SectionTilesProps.defaults
}

const ServiceIcon = ({ icon }) => (
  <div className="service-icon" aria-hidden="true">{icon}</div>
);

class FeaturesTiles extends React.Component {

  render() {

    const {
      className,
      topOuterDivider,
      bottomOuterDivider,
      topDivider,
      bottomDivider,
      hasBgColor,
      invertColor,
      pushLeft,
      ...props
    } = this.props;

    const outerClasses = classNames(
      'features-tiles section center-content',
      topOuterDivider && 'has-top-divider',
      bottomOuterDivider && 'has-bottom-divider',
      hasBgColor && 'has-bg-color',
      invertColor && 'invert-color',
      className
    );

    const innerClasses = classNames(
      'features-tiles-inner section-inner',
      topDivider && 'has-top-divider',
      bottomDivider && 'has-bottom-divider'
    );

    const tilesClasses = classNames(
      'tiles-wrap',
      pushLeft && 'push-left'
    );

    const sectionHeader = {
      title: 'What We Build',
      paragraph: 'From healthcare portals to business automations, we deliver technology that drives real results.'
    };

    const services = [
      {
        icon: '🏥',
        title: 'Healthcare Technology',
        description: 'Specialized platforms for insurance agents and brokers. We understand the regulatory and operational requirements of the healthcare industry—quoting engines, enrollment portals, and compliance tools.'
      },
      {
        icon: '⚙️',
        title: 'Business Automations',
        description: 'Eliminate repetitive manual work and reduce operational overhead. We design automation pipelines that connect your tools, sync your data, and keep your team focused on high-value work.'
      },
      {
        icon: '💻',
        title: 'Modern Web Applications',
        description: 'Full-stack React and Ruby development from a remote-first team of senior engineers. Scalable, performant, and built to last—for startups and enterprises alike.'
      },
      {
        icon: '📝',
        title: 'Quote, Proposal & Contract Workflows',
        description: 'Stop letting deals slip through the cracks. We build E-Sign and payment automation workflows that make your closing process consistent, fast, and trackable.'
      },
      {
        icon: '📊',
        title: 'Data & Reporting',
        description: 'Data is only as good as its display. We integrate modern BI tools so you can see your operations at a granular level—customizable dashboards built around your metrics.'
      },
      {
        icon: '🔗',
        title: 'CRM & API Integrations',
        description: 'Connect HubSpot, Salesforce, and industry-specific platforms through custom API integrations. If your tools don\'t talk to each other, we make them.'
      }
    ];

    return (
      <section
        id="services"
        {...props}
        className={outerClasses}
      >
        <div className="container">
          <div className={innerClasses}>
            <SectionHeader data={sectionHeader} className="center-content" />
            <div className={tilesClasses}>

              {services.map((service, index) => (
                <div className="tiles-item" key={index}>
                  <div className="tiles-item-inner service-card">
                    <div className="features-tiles-item-header">
                      <div className="features-tiles-item-image mb-16 reveal-from-top" data-reveal-container=".tiles-item">
                        <ServiceIcon icon={service.icon} />
                      </div>
                    </div>
                    <div className="features-tiles-item-content">
                      <h4 className="h5 mt-0 mb-8 reveal-from-top" data-reveal-container=".tiles-item" data-reveal-delay="100">
                        {service.title}
                      </h4>
                      <p className="m-0 text-sm reveal-from-top" data-reveal-container=".tiles-item" data-reveal-delay="200">
                        {service.description}
                      </p>
                    </div>
                  </div>
                </div>
              ))}

            </div>
          </div>
        </div>
      </section>
    );
  }
}

FeaturesTiles.propTypes = propTypes;
FeaturesTiles.defaultProps = defaultProps;

export default FeaturesTiles;
